<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <div class="d-flex align-items-center rnk-outer">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyWorker' }" class="tx-11" style="color: #444">Buddy ажилтан</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Шилдэг Buddy</li>
              </ol>
            </nav>

            <div class="mg-l-auto d-flex align-items-center">
              <div>Эрэмбэлэх : </div>
              <RadioGroup v-model="sortField" @change="init" class="mg-l-10" size="small">
                <RadioButton label="count">Buddy-лсан хүн</RadioButton>
                <RadioButton label="rate">Үнэлгээ</RadioButton>
              </RadioGroup>
            </div>
          </div>

          <div class="rnk-outer rounded-20 bg-white">
            <div v-for="(b, bi) in list" class="w-full bd-b">
              <div class="d-flex pd-20 align-items-center">
                <div class="mg-r-20">
                  <div v-if="bi==0" class="d-flex align-items-center justify-content-center tx-16 tx-bold bg-warning wd-50 ht-50 rounded-circle">
                    <feather type="award" style="width: 28px; height: 28px; color: white;"></feather>
                  </div>
                  <div v-else class="d-flex align-items-center justify-content-center text-3xl tx-bold bg-light wd-50 ht-50 rounded-circle">
                    {{ bi+1 }}
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <div>
                    <img class="rounded-circle wd-60" :src="b.avator" />
                  </div>
                  <div class="pd-l-20">
                    <div class="tx-semibold">{{ getFullName(b) }}</div>
                    <div class="text-muted">
                      <template v-if="b.departParent!=undefined">{{b.departParent.shortName}} - </template>{{b.depart.shortName}} - {{ b.position }}
                    </div>
                  </div>
                </div>
                <div class="mg-l-auto d-flex align-items-center">
                  <div>
                    <div class="tx-semibold">Buddy-лсан хүн</div>
                    <div class="text-muted text-right text-xl font-semibold">{{ b.activeNewbieCount }}</div>
                  </div>
                  <div class="mg-l-20 text-right">
                    <div class="tx-semibold">Үнэлгээ</div>
                    <div class="text-muted text-right text-xl font-semibold d-flex align-items-center">
                      <Rate v-model="b.rate" :disabled="true" />
                      <div style="cursor:help;" :title="`${b.ratedUserCount || 0} хүн үнэлгээ өгсөн`" class="mg-l-5">{{ b.ratedUserCount || 0 }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>
      <b-modal v-model="mdl.show" centered hide-footer size="lg">
        <iframe width="100%" height="460" src="https://www.youtube.com/embed/2f89d1vlyVo?si=VWxmLlE4KAO2gJZv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </b-modal>
    </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Rate, RadioGroup, RadioButton } from "element-ui";

import Masonry from "masonry-layout"

export default {
  components: {
    vueCustomScrollbar,
    Rate,
    RadioGroup,
    RadioButton,
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      sortField: 'count',
      myResBaseUrl: "https://res.gosmart.mn/",
      mdl:{
        show: false
      },
      curInd: 0,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      list: []
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    getFullName(b){
      let rv=b.firstName.toUpperCase();
      if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
          rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
      }
      return rv;
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/getTopBuddies" },
        data: { 
          sortField: this.sortField
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.list= res.data.list;
          console.log('res top', res);
        }
      });
    },
    
  },
};
</script>
<style lang="scss">
.rnk-outer{
  max-width: 50%;
  div:last-child{
    border: none;
  }
}
@media (max-width: 1440px) { /* Adjust the width as needed */
  .rnk-outer {
    max-width: 60%;
  }
}
@media (max-width: 992px) { /* Adjust the width as needed */
  .rnk-outer {
    max-width: 100%;
  }
}
</style>